import { cycleSort, type SortColumn, type SortState } from './gridSort';

// P2b-3 §6.2: clickable column-header that cycles asc → desc → none on
// repeated clicks. Used inside <th> cells in both role grids. The arrow
// indicator (▲ / ▼) appears only when this column is the active sort,
// so the rest of the header row stays visually quiet.

type Props = {
  column: SortColumn;
  label: string;
  sort: SortState;
  onChange: (next: SortState) => void;
};

export function SortableHeaderButton({ column, label, sort, onChange }: Props) {
  const active = sort?.column === column;
  const arrow = !active ? '' : sort?.direction === 'asc' ? ' ▲' : ' ▼';
  return (
    <button
      type="button"
      onClick={() => onChange(cycleSort(sort, column))}
      aria-label={`Sort by ${label}`}
      className={
        'inline-flex items-center gap-1 hover:text-slate-900 ' +
        (active ? 'text-slate-900 font-semibold' : 'text-slate-500')
      }
    >
      {label}
      <span aria-hidden className="text-[10px]">{arrow}</span>
    </button>
  );
}
